// import React, { useEffect, useState } from "react";
// import "./mainCategories.css";

// export default function EditMainCategoryModal({ initialData, onClose, onUpdate }) {
//   const [name, setName] = useState(initialData?.name || "");
//   const [status, setStatus] = useState(initialData?.status || "Active");
//   const [imageFile, setImageFile] = useState(null);
//   const [preview, setPreview] = useState(initialData?.image || "");
//   const [err, setErr] = useState("");

//   useEffect(() => {
//     setName(initialData?.name || "");
//     setStatus(initialData?.status || "Active");
//     setPreview(initialData?.image || "");
//     setImageFile(null);
//   }, [initialData]);

//   const onFile = (e) => {
//     const f = e.target.files?.[0];
//     if (!f) return;
//     setImageFile(f);
//     setPreview(URL.createObjectURL(f));
//   };

//   const submit = (e) => {
//     e.preventDefault();
//     setErr("");

//     if (!name.trim()) {
//       setErr("Category name required");
//       return;
//     }

//     onUpdate({
//       id: initialData.id,
//       name: name.trim(),
//       status,
//       imageFile, // optional
//     });
//   };

//   return (
//     <div className="mc-overlay" onMouseDown={onClose}>
//       <div className="mc-modal" onMouseDown={(e) => e.stopPropagation()}>
//         <div className="mc-modalHead">
//           <h3>Edit Main Category</h3>
//           <button className="mc-x" onClick={onClose}>✕</button>
//         </div>

//         <form onSubmit={submit} className="mc-form">
//           {err && <div className="mc-err">{err}</div>}

//           <label className="mc-label">Category Name</label>
//           <input
//             className="mc-input"
//             value={name}
//             onChange={(e) => setName(e.target.value)}
//             placeholder="Enter category name"
//           />

//           <label className="mc-label">Status</label>
//           <select
//             className="mc-input"
//             value={status}
//             onChange={(e) => setStatus(e.target.value)}
//           >
//             <option value="Active">Active</option>
//             <option value="Inactive">Inactive</option>
//           </select>

//           <label className="mc-label">Image (optional)</label>
//           <input className="mc-input" type="file" accept="image/*" onChange={onFile} />

//           {preview ? (
//             <img src={preview} alt="preview" className="mc-preview" />
//           ) : (
//             <div className="mc-noimg">No image</div>
//           )}

//           <div className="mc-actionsRow">
//             <button type="button" className="mc-btn ghost" onClick={onClose}>
//               Cancel
//             </button>
//             <button type="submit" className="mc-btn">
//               Update
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// }

//new

import React, { useEffect, useState } from "react";
import "./mainCategories.css";

export default function EditMainCategoryModal({ initialData, onClose, onUpdate }) {
  const [name, setName] = useState(initialData?.name || "");
  const [status, setStatus] = useState(initialData?.status || "Active");
  const [imageFile, setImageFile] = useState(null);
  const [preview, setPreview] = useState(initialData?.image || "");
  const [err, setErr] = useState("");

  useEffect(() => {
    setName(initialData?.name || "");
    setStatus(initialData?.status || "Active");
    setPreview(initialData?.image || "");
    setImageFile(null);
  }, [initialData]);

  const onFile = (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setImageFile(f);
    setPreview(URL.createObjectURL(f));
  };

  const submit = (e) => {
    e.preventDefault();
    setErr("");
    if (!name.trim()) { setErr("Category name is required"); return; }
    onUpdate({ id: initialData.id, name: name.trim(), status, imageFile });
  };

  return (
    <div className="mc-overlay" onMouseDown={onClose}>
      <div className="mc-modal" onMouseDown={(e) => e.stopPropagation()}>

        {/* Header */}
        <div className="mc-modal-head">
          <div className="mc-modal-head-left">
            <div className="mc-modal-icon mc-modal-icon-edit">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"/>
                <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"/>
              </svg>
            </div>
            <div>
              <h3 className="mc-modal-title">Edit Category</h3>
              <p className="mc-modal-sub">Update "{initialData?.name}"</p>
            </div>
          </div>
          <button className="mc-close-btn" onClick={onClose}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
              <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        </div>

        {/* Body */}
        <form onSubmit={submit} className="mc-modal-body">
          {err && (
            <div className="mc-form-err">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" style={{flexShrink:0}}>
                <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
              </svg>
              {err}
            </div>
          )}

          <div className="mc-form-group">
            <label className="mc-label">Category Name</label>
            <input
              className="mc-input"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Enter category name"
              autoFocus
            />
          </div>

          <div className="mc-form-group">
            <label className="mc-label">Status</label>
            <select className="mc-input mc-select" value={status} onChange={(e) => setStatus(e.target.value)}>
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </select>
          </div>

          <div className="mc-form-group">
            <label className="mc-label">Category Image <span className="mc-label-opt">(optional — leave empty to keep current)</span></label>
            <label className="mc-file-label">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                <rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/>
                <polyline points="21 15 16 10 5 21"/>
              </svg>
              {imageFile ? imageFile.name : "Replace image…"}
              <input type="file" accept="image/*" onChange={onFile} style={{display:"none"}} />
            </label>
            {preview ? (
              <div className="mc-preview-wrap">
                <img src={preview} alt="preview" className="mc-preview" />
                <button type="button" className="mc-preview-remove" onClick={() => { setPreview(""); setImageFile(null); }}>
                  Remove
                </button>
              </div>
            ) : (
              <div className="mc-no-preview">No image</div>
            )}
          </div>

          <div className="mc-modal-footer">
            <button type="button" className="mc-btn-cancel" onClick={onClose}>Cancel</button>
            <button type="submit" className="mc-btn-save mc-btn-update">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                <polyline points="20 6 9 17 4 12"/>
              </svg>
              Update Category
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}